(ns web3.screens.pro.utils
  (:require [web3.modals.forms :as forms]
            [web3.forms.fields :as fields]
            [clojure.string :as str]
            [web3.utils :as utils]
            [web3.env :as env]
            [web3.queries.root :as q-root]))

(def icon-flag
  [:svg
   {:width "48px", :height "20px", :view-box "0 0 48 20", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-15.000000, -361.000000)"}
     [:g
      {:transform "translate(15.000000, 361.000000)"}
      [:g
       {}
       [:polygon {:fill "currentColor", :points "0 0.0002 0 20.0002 47.165 20.0002 37.165 10.0002 47.165 0.0002"}]
       [:g
        {:transform "translate(6.000000, 5.000000)", :fill "white"}
        [:path
         {:d "M2.2031,4.4609 L3.1051,4.4609 C3.4261,4.4609 3.6831,4.3569 3.8791,4.1469 C4.0741,3.9369 4.1721,3.6599 4.1721,3.3149 C4.1721,2.9709 4.0741,2.6949 3.8791,2.4869 C3.6831,2.2799 3.4261,2.1759 3.1051,2.1759 L2.2031,2.1759 L2.2031,4.4609 Z M0.5211,9.2009 L0.5211,0.7989 L3.1051,0.7989 C3.9331,0.7989 4.5991,1.0259 5.1001,1.4819 C5.6021,1.9369 5.8531,2.5479 5.8531,3.3149 C5.8531,4.0829 5.6011,4.6949 5.0981,5.1519 C4.5941,5.6089 3.9301,5.8379 3.1051,5.8379 L2.2031,5.8379 L2.2031,9.2009 L0.5211,9.2009 Z"}]
        [:path
         {:d "M8.6074,4.4609 L9.6274,4.4609 C9.9474,4.4609 10.2054,4.3569 10.4004,4.1469 C10.5954,3.9369 10.6934,3.6599 10.6934,3.3149 C10.6934,2.9709 10.5954,2.6949 10.4004,2.4869 C10.2054,2.2799 9.9474,2.1759 9.6274,2.1759 L8.6074,2.1759 L8.6074,4.4609 Z M6.9254,9.2009 L6.9254,0.7989 L9.6274,0.7989 C10.4554,0.7989 11.1204,1.0269 11.6224,1.4829 C12.1244,1.9399 12.3754,2.5509 12.3754,3.3149 C12.3754,3.8579 12.2424,4.3289 11.9764,4.7299 C11.7114,5.1289 11.3434,5.4229 10.8754,5.6099 L12.8204,9.2009 L10.9744,9.2009 L9.3044,5.8379 L8.6074,5.8379 L8.6074,9.2009 L6.9254,9.2009 Z"}]
        [:path
         {:d "M15.627,2.918 C15.139,3.452 14.895,4.145 14.895,4.997 C14.895,5.85 15.139,6.543 15.627,7.079 C16.115,7.615 16.75,7.883 17.531,7.883 C18.313,7.883 18.948,7.615 19.439,7.079 C19.929,6.543 20.174,5.85 20.174,4.997 C20.174,4.145 19.929,3.452 19.439,2.918 C18.948,2.384 18.313,2.117 17.531,2.117 C16.75,2.117 16.115,2.384 15.627,2.918 M13.755,7.252 C13.394,6.597 13.213,5.846 13.213,4.997 C13.213,4.148 13.394,3.397 13.755,2.744 C14.116,2.091 14.624,1.584 15.278,1.223 C15.933,0.862 16.684,0.682 17.531,0.682 C18.383,0.682 19.136,0.862 19.79,1.223 C20.444,1.584 20.951,2.091 21.311,2.744 C21.67,3.397 21.85,4.148 21.85,4.997 C21.85,5.846 21.67,6.597 21.311,7.252 C20.951,7.907 20.444,8.415 19.79,8.776 C19.136,9.138 18.383,9.318 17.531,9.318 C16.684,9.318 15.933,9.138 15.278,8.776 C14.624,8.415 14.116,7.907 13.755,7.252"}]]]]]]])

(defn encode-referral-link [s]
  (some-> (str/replace s #"[^0-9]" "")
          (subs 0 10)))

(defn decode-referral-link [s]
  (when s
    (let [[n1 n2 n3 n4 n5 n6 n7 n8 n9 n0] (encode-referral-link s)]
      (str n1 n2 n3 (when n4 \-) n4 n5 n6 (when n7 \-) n7 n8 n9 n0))))

(defn k-path [k]
  (cond-> k
    (keyword? k) (vector)))

(defn simplify-path [k]
  (if (keyword? k)
    (utils/simplify-keyword k)
    (update k (dec (count k)) utils/simplify-keyword)))

(defn pro?
  []
  (and (:feature/pro? env/config)
    (some-> (q-root/me)
            :me
            :proPlan
            (not= "none"))))

(defn render-field
  "Render pro-flow field, given parent component and field key."
  ([parent-component k]
   (render-field parent-component k {}))
  ([parent-component k props]
   (fields/from-schema k
                       (->
                        (forms/field-props (:state parent-component) k)
                        (update :value #(or % (get-in (q-root/me) (into [:me] (-> k
                                                                                  (k-path)
                                                                                  (simplify-path))))))
                        (merge props)))))
